/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import styles from './SectionShell.module.scss';

import type { SectionShellProps } from './SectionShell.types';

export const SectionShell = ({ id, title, tone = 'default', className, children }: SectionShellProps) => (
  <section id={id} className={cn(styles['section'], styles[`tone-${tone}`], className)}>
    <TitleBlock align="left" accent="none" fullWidth title={title} className={styles['heading']} />

    <div className={styles['body']}>{children}</div>
  </section>
);
